var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMockTest = function SvgIconMockTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16.403 4H3.597A.597.597 0 0 0 3 4.597v8.973c0 .33.267.597.597.597h12.806c.33 0 .597-.267.597-.597V4.597A.597.597 0 0 0 16.403 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.352 16.526a1.97 1.97 0 0 0 1.05-2.366M12.91 16.526a1.97 1.97 0 0 1-1.049-2.366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M5.71 16.527h8.577M5.505 7.42l.858.6 1.061-1.493M5.38 10.318l.856.597 1.061-1.493M9 8h6.157M8.994 10.52h6.157"
  })));
};
export default SvgIconMockTest;